import { AmplifyGet } from '@sunrun/sales-experience-shared/amplify-api-wrapper';
import useSWR from 'swr';
import { useHybridToken } from 'providers/Auth';
import { logger } from 'providers/logger';
import { useUserProfile } from 'providers/UserProfile';

type Announcement = {
  title: string;
  createdAt: string;
  link?: string;
  body?: string;
  expiresAt?: string;
  announcementId: string;
};

async function fetchAnnouncementsList(
  hybridToken: string,
): Promise<Announcement[]> {
  const data = await AmplifyGet<Announcement[]>(
    'Get Announcements',
    'SalesExpDashboardApi',
    `/announcements`,
    {
      headers: {
        Authorization: `Bearer ${hybridToken}`,
      },
    },
    logger,
  );
  return data;
}

const useAnnouncementsFromApi = (): {
  announcements: Announcement[];
  isAnnouncementsLoading: boolean;
  announcementsError: Error | undefined;
} => {
  const { userProfile } = useUserProfile();
  const { hybridToken } = useHybridToken();

  const { data, error, isLoading } = useSWR(
    hybridToken && userProfile ? [`/announcements`, hybridToken] : null,
    ([, token]) => fetchAnnouncementsList(token as string),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    },
  );

  return {
    announcements: data ?? [],
    isAnnouncementsLoading: isLoading,
    announcementsError: error,
  };
};

export { type Announcement, fetchAnnouncementsList, useAnnouncementsFromApi };
